import { transformNullishFromData } from "@/utils/transforms";

export default {
	state: {
		default: {
			reopenDeadline: {
				id: 0,
				competence: null,
				justification: null,
				denialReason: null,
				regional: null,
				userId: 0,
				suppliesTypesId: 0,
				reopeningStatusId: 0,
				user: null,
				suppliesTypes: null,
				reopeningStatus: null
			}
		},
		data: {
			reopenDeadline: {},
		}
	},

	getters: {
		getReopenDeadlineData (state) {
			return state.data.reopenDeadline;
		},

		getDefaultReopenDeadlineData (state) {
			return state.default.reopenDeadline;
		}
	},

	mutations: {
		setReopenDeadlineData (state, data) {
			state.data.reopenDeadline = transformNullishFromData(data);
		}
	},

	actions: {
		changeReopenDeadlineData (context, info) {
			context.commit("setReopenDeadlineData", info);
		}
	}
}